module.exports = __webpack_public_path__ + "static/paralaneGeometry-7c3e7154ee604f904b5e2207348f7730.jpg";